<template>
  <div class="risk-assessment-box">
    <bCardHeader :param="param"></bCardHeader>
    <div class="risk-container">
      <div class="top-title">{{$t('fund.riskAssess')}}</div>
      <div class="user-info">
        <div class="name">{{$t('fund.name')}}{{user.name}}</div>
        <div>{{$t('fund.idText')}}{{user.idNumber}}</div>
      </div>
      <div class="risk-content">
        <div class="title">{{$t('fund.chooseAppropriate')}}</div>
        <div class="content">
          <div class="item" v-for="(item,index) in answerList" :key="index">
            <div class="item-title">{{item.questionNumber}}、{{item.question}}</div>
            <div class="item-topic" v-if="item.type==='single'">
              <el-radio-group v-model="item.answer" :disabled="item.questionNumber === 1 && item.answer ? true : false"
                class="radio-group" @change="changeHandle($event,item.questionNumber)">
                <el-radio :label="val.value" v-for="(val,key) in item.options" :key="key">{{val.value}}. {{val.label}}</el-radio>
              </el-radio-group>
            </div>
            <div class="item-topic" v-else>
              <el-checkbox-group v-model="item.answer" class="checkbox-group" >
                <el-checkbox @change="checkHandle(item, val)" v-for="(val,key) in item.options" :key="key" :label="val.value" :data-single="val.single">{{val.value}}. {{val.label}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="agree-info">
        <el-checkbox v-model="agreement"
                     :label="agreement">{{$t('fund.agreeRiskText')}}</el-checkbox>
      </div> -->
      <div class="btn-box">
        <div class="cancel" @click="cancelHandle">{{$t('setting.setPassword.cancel')}}</div>
        <div class="apply" @click="submitHandle">{{$t('setting.setPassword.submit')}}</div>
        <div class="total-box">{{$t('fund.all')}}<span
            class="special-num">{{total}}</span>{{$t('fund.specialText')}}<span
            class="special-num">{{selectNum}}</span>{{$t('fund.daoti')}}</div>
      </div>
      <div class="disclaimer">
        <div class="title">{{$t('fund.Disclaimer')}}</div>
        <div class="content">
          <div  v-html="$t('fund.disclaimerText1')"></div>
          <div  v-html="$t('fund.disclaimerText2')"></div>
          <!-- <div  v-html="$t('fund.disclaimerText3')"></div> -->
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="34%" :title="$t('fund.dialogTitle')" class="cancel-box"
      :close-on-click-modal="false" :show-close="false">
      <div class="text">{{$t('fund.notBackInfo')}}</div>
      <div class="btns">
        <div class="top" @click="dialogVisible=false">{{$t('common.cancel')}}</div>
        <div class="bottom" @click="handleBack">{{$t('common.ok')}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { riskQuestions, fundCashRiskAssessment } from '@/api/v2/fund'

import { mapState } from 'vuex'
import eventBus from '@/util/eventBus'
export default {
  data() {
    return {
      param: {
        title: 'other_account',
        links: [
          {
            title: 'home'
          },
          {
            title: 'my_account'
          },
          {
            title: 'other_account'
          }
        ]
      },
      radio: '',
      checkList: [],
      user: '',
      answerList: [],
      total: 10,
      answerParamsList: [],
      isClick: false,
      dialogVisible: false,
      isAnswer: false,
      toLink: '',
      sourceOfFunds: [],
      fundsSource: '',
      employment: '',
      employmentList: [
        {
          label: this.$t('quotes.employmentSelector.Employment'),
          val: 'employed'
        },
        {
          label: this.$t('quotes.employmentSelector.selfCare'),
          val: 'self'
        },
        {
          label: this.$t('quotes.employmentSelector.retirement'),
          val: 'retired'
        },
        {
          label: this.$t('quotes.employmentSelector.Unemployed'),
          val: 'unemployed'
        }
      ]

    }
  },

  computed: {
    ...mapState(['userInfo']),
    selectNum() {
      let hasanswer = this.answerParamsList.filter(item => {
        return item.answer
      })
      return hasanswer.length || 0
    }
  },
  watch: {
    'answerParamsList': {
      handler: (val) => {
        let hasAnswer = val.filter(item => {
          return item.answer
        })
        if (hasAnswer.length) {
          localStorage.setItem('notNeedPush', 'yes')
        } else {
          localStorage.removeItem('notNeedPush')
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    localStorage.removeItem('notNeedPush')
  },
  created() {
    this.getRiskQuestions()
  },
  mounted() {
    eventBus.$on('openDialog', (index) => {
      console.log('event', index)
      this.toLink = index
      this.dialogVisible = true
    })
    // history.pushState(null, null, document.URL)
    // window.addEventListener('popstate', () => {
    //   console.log('99999')
    //   this.cancelHandle()
    // })
  },
  methods: {
    handleBack() {
      localStorage.removeItem('notNeedPush')
      if (this.toLink) {
        this.$router.push(this.toLink)
      } else {
        this.$router.go(-1)
      }
    },
    async getRiskQuestions() {
      let res = await riskQuestions()
      if (res && res.code === 200) {
        this.user = res.data && res.data.user
        let data = (res.data && res.data.jsonText) || []
        data = this.setSingleOption(data)
        let tempData = JSON.parse(JSON.stringify(data))
        tempData.forEach(item => {
          if (item.type === 'single') {
            item.answer = item.answer || ''
          } else {
            item.answer = item.answer ? item.answer.split(',') : []
          }
        })
        this.answerList = tempData
        this.answerParamsList = (res.data && res.data.jsonText) || []
        this.total = this.answerList.length
        this.employment = this.user.employmentStatus
      }
    },
    setSingleOption(jsonText) {
      jsonText.forEach(item => {
        if (item.questionNumber === 6) {
          item.options.forEach(option => {
            if (option.value === 'F' || option.value === 'G') {
              option.single = true
            }
          })
        }
        if (item.questionNumber === 7) {
          item.options.forEach(option => {
            if (option.value === 'A') {
              option.single = true
            }
          })
        }
      })
      return jsonText
    },
    cancelHandle() {
      let hasAnswer = this.answerParamsList.some(item => {
        return item.answer
      })
      if (hasAnswer) {
        this.dialogVisible = true
      } else {
        this.$router.go(-1)
      }
    },
    changeHandle(val, num) {
      this.$set(this.answerParamsList[num - 1], 'answer', val)
    },
    checkHandle(item, val) {
      if (val.single) {
        item.answer = [val.value]
        this.$set(this.answerParamsList[item.questionNumber - 1], 'answer', val.value)
      } else {
        const selectedOptions = item.options.find(option => {
           return item.answer.includes(option.value) && option.single
        })
        if (selectedOptions) {
          this.$set(this.answerParamsList[item.questionNumber - 1], 'answer', val.value)
          item.answer = [val.value]
        } else {
          this.$set(this.answerParamsList[item.questionNumber - 1], 'answer', item.answer.join(','))
        }
      }
      console.log(this.answerParamsList, 'this.answerParamsList')
      // let value = val.join(',')
      // this.$set(this.answerParamsList[num - 1], 'answer', item.answer)
    },
    async submitHandle() {
      this.isClick = true
      let arr = this.answerParamsList.map(item => {
        return {
          answer: item.answer,
          questionNumber: item.questionNumber
        }
      })
      let notCheck = arr.some(item => {
        console.log(item.answer)
        return !item.answer
      })
      if (notCheck) {
        return this.$message.error(this.$t('fund.chooseAppropriate'))
      }
      let params = {
        // agreement: false,
        answerList: arr,
        idNumber: this.user.idNumber,
        name: this.user.name,
        submitSource: 'CP_WEB'
        // employmentStatus: this.employment
      }
      let res = await fundCashRiskAssessment(params)
      if (res && res.code === 200) {
        this.$router.replace({
          path: '/risk-level',
          query: {
            isLatest: true
          }
        })
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.risk-assessment-box {
  .risk-container {
    background: #ffffff;
    box-shadow: 0px 3px 7px 0px rgba(179, 179, 179, 0.5);
    border-radius: 5px;
    min-height: 800px;
    padding: 14px 30px 30px;
  }
  .top-title {
    font-size: 18px;
    font-weight: 600;
    color: #182a54;
    line-height: 30px;
    padding-bottom: 16px;
    border-bottom: 3px solid #ebebeb;
    margin-bottom: 19px;
  }
  .user-info {
    background: #f5f6f7;
    border-radius: 4px;
    padding: 18px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #24282d;
    line-height: 15px;
    margin-bottom: 24px;
    .name {
      margin-right: 72px;
    }
  }
  .risk-content {
    margin-bottom: 20px;
    .title {
      font-size: 15px;
      font-weight: 400;
      color: #24282d;
      line-height: 16px;
      padding-left: 10px;
      position: relative;
      margin-bottom: 15px;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        width: 4px;
        height: 15px;
        background: #3370ff;
      }
    }
    .content {
      border-radius: 6px;
      border: 1px solid #dee0e3;
      padding: 0 0 10px 0;
      .item {
        padding: 0 20px 28px;
        border-bottom: 1px solid #dee0e3;
        &:last-of-type {
          border-bottom: none;
        }
      }
      .error {
        font-size: 14px;
        font-weight: 400;
        color: #f13e3d;
        line-height: 18px;
        padding-top: 8px;
      }
      .item-title {
        font-size: 15px;
        font-weight: 500;
        color: #24282d;
        line-height: 20px;
        margin-bottom: 20px;
        padding-top: 20px;
      }
      .radio-group {
        display: flex;
        flex-direction: column;
      }
      .checkbox-group {
        display: flex;
        flex-direction: column;
      }
      .check-spe {
        margin-bottom: 15px;
      }
      /deep/ .el-radio {
        margin-bottom: 15px;
        font-size: 14px;
        font-weight: normal;
        color: #24282d;
        line-height: 18px;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      /deep/ .el-checkbox {
        margin-bottom: 15px;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      /deep/ .el-checkbox__inner {
        border-radius: 3px;
      }
      /deep/ .el-radio__inner::after {
        width: 7px;
        height: 7px;
      }
      /deep/ .el-radio__input.is-checked .el-radio__inner {
        border-color: #2d60e0;
        background: #2d60e0;
      }
      /deep/ .el-radio__input.is-checked + .el-radio__label {
        color: #24282d;
      }
      /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #2d60e0;
        background: #2d60e0;
      }
      /deep/ .el-checkbox__label {
        font-size: 14px !important;
        font-weight: normal;
        color: #24282d;
        line-height: 18px;
        padding-left: 8px !important;
        white-space: normal;
        vertical-align: middle;
        word-break: break-word;
      }
      /deep/ .el-radio + .el-radio {
        margin-left: 0;
      }
      /deep/ .el-checkbox + .el-checkbox {
        margin-left: 0;
      }
      /deep/ .el-radio__label {
        border-color: #2d60e0;
        white-space: normal;
        vertical-align: middle;
        word-break: break-word;
      }
    }
  }
  .special-ques {
    margin-top: 15px;
    border-top: 1px solid #dee0e3;
    padding-top: 15px;
    .title-spe {
      font-size: 15px;
      font-weight: 500;
      color: #24282d;
      line-height: 20px;
      margin-bottom: 15px;
    }
  }
  .agree-info {
    margin-bottom: 27px;
    /deep/ .el-checkbox__label {
      margin-left: 8px;
    }
    /deep/ .el-checkbox .el-checkbox__label {
      font-size: 15px;
      font-weight: 400;
      color: #24282d;
      line-height: 20px;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      border-color: #2d60e0;
      background: #2d60e0;
    }
  }
  .btn-box {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: #192b57;
    line-height: 20px;
    margin-bottom: 20px;
    .cancel {
      border-radius: 5px;
      border: 1px solid #20315c;
      width: 185px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      box-sizing: border-box;
      margin-right: 30px;
      cursor: pointer;
    }
    .apply {
      background: #fec000;
      border-radius: 5px;
      width: 185px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
      margin-right: 10px;
    }
  }
  .total-box {
    font-size: 14px;
    font-weight: 400;
    color: #24282d;
    line-height: 18px;
    .special-num {
      color: #2d60e0;
      font-size: 18px;
    }
  }
  .disclaimer {
    .title {
      font-size: 15px;
      font-weight: 500;
      color: #24282d;
      line-height: 16px;
      margin-bottom: 20px;
    }
    .content {
      background: #f9fbff;
      padding: 10px;
      font-size: 13px;
      font-weight: 400;
      color: #868e9e;
      line-height: 20px;
      & >div{
        margin-bottom: 10px;
      }
    }
  }
  .cancel-box {
    margin: 0 auto;
    /deep/ .el-dialog__header {
      margin: 44px 49px 12px;
      padding: 0;
      padding-top: 44px;
      border-bottom: 3px solid #e2e2e2;
    }
    /deep/ .el-dialog__headerbtn {
      right: 30px;
      font-size: 18px;
    }
    /deep/ .el-dialog__title {
      font-size: 22px;
      font-weight: 600;
      color: #24282d;
      line-height: 41px;
    }
    /deep/ .el-dialog__body {
      padding: 0 49px 30px;
    }
    .text {
      font-size: 14px;
      font-weight: 600;
      color: #24282d;
      line-height: 20px;
    }
  }
  .btns {
    font-size: 14px;
    font-weight: 600;
    color: #193060;
    line-height: 20px;
    width: 50%;
    margin: auto;
    text-align: center;
    padding-top: 30px;
    .top {
      background: #fec000;
      border-radius: 5px;
      padding: 15px 0;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .bottom {
      border-radius: 5px;
      border: 1px solid #193060;
      padding: 15px 0;
      cursor: pointer;
    }
  }
}
</style>
